import { useCallback, useEffect, useState } from "react";
import API, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

export function useNotificationPrefs() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(() => API.get("/client-hub/settings/notifications").then((r) => setData(r.data)).catch((e) => setError(formatApiError(e?.response?.data?.detail))), []);
  useEffect(() => { load(); }, [load]);

  const push = useCallback(async (body, optimistic) => {
    let prev;
    setData((d) => { prev = d; return optimistic ? optimistic(d) : d; });
    try { const { data: fresh } = await API.put("/client-hub/settings/notifications", body); setData(fresh); return true; }
    catch (e) { setData(prev); toast.error(formatApiError(e?.response?.data?.detail) || "Could not save"); return false; }
  }, []);

  const sendPending = useCallback(async () => {
    try {
      const { data: res } = await API.post("/client-hub/settings/notifications/send-pending");
      setData((d) => (d ? { ...d, pending: res.pending } : d));
      toast.success(res.sent ? `Sent ${res.sent} waiting email${res.sent === 1 ? "" : "s"} as one message` : "Nothing waiting to send");
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Could not send"); }
  }, []);

  return { data, error, push, sendPending, reload: load };
}

export const fmtWhen = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" });
  return sameDay ? `today ${time}` : `${d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", timeZone: "Europe/London" })} ${time}`;
};
